export default function SourceCandidateIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2727 3.41805C12.4023 3.06781 12.8977 3.06781 13.0273 3.41805L13.2372 3.98534C13.4817 4.64603 14.0026 5.16695 14.6633 5.41143L15.2306 5.62134C15.5808 5.75094 15.5808 6.24632 15.2306 6.37592L14.6633 6.58584C14.0026 6.83031 13.4817 7.35123 13.2372 8.01193L13.0273 8.57921C12.8977 8.92945 12.4023 8.92945 12.2727 8.57921L12.0628 8.01193C11.8183 7.35123 11.2974 6.83031 10.6367 6.58584L10.0694 6.37592C9.71918 6.24632 9.71918 5.75094 10.0694 5.62134L10.6367 5.41143C11.2974 5.16695 11.8183 4.64603 12.0628 3.98534L12.2727 3.41805Z"
        fill="#667085"
      />
      <path
        d="M8.75036 3C9.44815 3.00003 10.1213 3.10574 10.7544 3.30236C10.5106 3.86313 10.0629 4.31061 9.50187 4.55399C9.25639 4.51878 9.00558 4.49951 8.75036 4.49949C5.85054 4.49949 3.49949 6.85054 3.49949 9.75036C3.49965 12.6501 5.85064 15.0003 8.75036 15.0003C11.65 15.0002 14.0002 12.65 14.0003 9.75036C14.0003 9.64082 13.9955 9.53215 13.9889 9.42427L14.0461 9.27045C14.2627 8.68515 14.6956 8.20882 15.2511 7.93796C15.4116 8.51491 15.4998 9.12228 15.4998 9.75036C15.4998 11.3389 14.9495 12.7979 14.0311 13.9509L16.7822 16.7222C17.0739 17.016 17.0724 17.4905 16.7787 17.7822C16.4849 18.0739 16.0105 18.0724 15.7187 17.7787L12.9737 15.0135C11.8173 15.9427 10.3493 16.4998 8.75036 16.4998C5.0225 16.4998 2.00016 13.4782 2 9.75036C2 6.0224 5.0224 3 8.75036 3Z"
        fill="#667085"
      />
    </svg>
  );
}
